import React from "react";

const SuccessToast = ({ message, variant = "success" }) => {
  if (!message) return null;

  const toneClass =
    variant === "error"
      ? "bg-red-600"
      : "bg-emerald-600";

  return (
    <div className={`fixed top-5 right-5 z-[60] text-white px-4 py-2 rounded-lg shadow-xl text-sm font-bold ${toneClass}`}>
      {message}
    </div>
  );
};

export default SuccessToast;